import type { SVGMotionProps, Transition } from 'motion/react'
import { motion } from 'motion/react'

const transition: Transition = {
  duration: 0.7,
  type: 'spring',
  bounce: 0.7,
}

export const Objects = ({
  isHovered,
  ...props
}: SVGMotionProps<SVGSVGElement> & { isHovered?: boolean }) => {
  return (
    <motion.svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      whileHover="hover"
      animate={isHovered ? 'hover' : undefined}
      {...props}
    >
      <motion.path
        transition={transition}
        initial={{ y: 0 }}
        variants={{ hover: { rotate: 45 } }}
        fill="currentColor"
        fillRule="evenodd"
        d="M13.945 3.512a3.277 3.277 0 0 1-.863-.359l-.292-.174c-.258-.153-.55.14-.397.398l.174.291a3.361 3.361 0 0 1 .265.559 3.284 3.284 0 0 1-.265 2.803l-.174.292c-.154.258.14.55.397.397l.292-.174a3.351 3.351 0 0 1 .863-.359 3.29 3.29 0 0 1 2.499.36l.292.173c.258.154.55-.14.397-.397l-.174-.292a3.298 3.298 0 0 1-.359-.863 3.29 3.29 0 0 1 .36-2.499l.173-.292c.154-.258-.14-.55-.397-.397l-.292.174a3.296 3.296 0 0 1-.863.359 3.29 3.29 0 0 1-1.636 0Zm1.834 5.15.292.174c1.417.844 3.022-.762 2.179-2.179l-.174-.292a1.986 1.986 0 0 1 0-2.032l.174-.291c.843-1.417-.762-3.023-2.18-2.18l-.291.174a1.987 1.987 0 0 1-2.032 0l-.292-.174c-1.417-.843-3.023.763-2.18 2.18l.175.291a1.986 1.986 0 0 1 0 2.032l-.174.292c-.844 1.417.762 3.023 2.18 2.18l.29-.174a1.987 1.987 0 0 1 2.033 0Z"
        clipRule="evenodd"
      />
      <motion.path
        fill="currentColor"
        fillRule="evenodd"
        d="M5.313 18.456a3.93 3.93 0 1 0 0-7.86 3.93 3.93 0 0 0 0 7.86Zm0-1.3a2.63 2.63 0 1 0 0-5.26 2.63 2.63 0 0 0 0 5.26Z"
        clipRule="evenodd"
      />
      <motion.path
        fill="currentColor"
        fillRule="evenodd"
        d="M4.18 2.868c-.284.023-.428.065-.528.116a1.282 1.282 0 0 0-.56.56c-.05.1-.092.243-.115.527-.024.291-.024.668-.024 1.222 0 .554 0 .931.024 1.222.023.284.065.428.115.527.123.241.32.437.56.56.1.05.244.093.527.116.291.023.668.024 1.222.024.555 0 .932 0 1.223-.024.283-.023.427-.065.526-.116.242-.123.438-.319.56-.56.051-.1.093-.243.116-.527.024-.29.024-.668.024-1.222 0-.554 0-.931-.024-1.222-.023-.284-.065-.427-.115-.527a1.282 1.282 0 0 0-.56-.56c-.1-.05-.244-.092-.527-.116A16.798 16.798 0 0 0 5.4 2.844c-.554 0-.93 0-1.222.024Zm1.195-1.324h.053c.521 0 .951 0 1.301.029.363.03.698.093 1.012.253.486.247.88.642 1.128 1.128.16.314.223.648.253 1.012.028.35.028.78.028 1.3v.054c0 .52 0 .95-.028 1.3-.03.364-.093.699-.253 1.012-.248.486-.642.881-1.128 1.129-.314.16-.649.223-1.012.253-.35.028-.78.028-1.3.028h-.054c-.521 0-.951 0-1.301-.028-.363-.03-.698-.093-1.012-.253a2.582 2.582 0 0 1-1.128-1.129c-.16-.313-.223-.648-.253-1.011-.028-.35-.028-.78-.028-1.301v-.054c0-.52 0-.95.028-1.3.03-.364.093-.698.253-1.012.247-.486.642-.88 1.128-1.128.314-.16.649-.224 1.012-.253.35-.029.78-.029 1.3-.029Z"
        clipRule="evenodd"
      />
      <motion.path
        fill="currentColor"
        fillRule="evenodd"
        d="M13.646 12.19c-.283.023-.427.064-.527.115a1.282 1.282 0 0 0-.56.56c-.05.1-.092.243-.115.527-.024.291-.025.668-.025 1.222 0 .554 0 .931.025 1.222.023.284.064.428.115.527.123.241.32.437.56.56.1.05.244.093.527.116.291.023.668.024 1.222.024.555 0 .931 0 1.222-.024.284-.023.428-.065.527-.116.241-.123.438-.319.56-.56.051-.1.093-.243.116-.527.024-.29.024-.668.024-1.222 0-.554 0-.931-.024-1.222-.023-.284-.065-.428-.116-.527a1.282 1.282 0 0 0-.56-.56c-.1-.05-.243-.092-.527-.116a16.786 16.786 0 0 0-1.222-.024c-.554 0-.93 0-1.222.024Zm1.196-1.325h.053c.521 0 .95 0 1.3.029.364.03.699.093 1.013.253.485.247.88.642 1.128 1.128.16.314.223.648.253 1.012.028.35.028.78.028 1.3v.054c0 .52 0 .95-.028 1.3-.03.364-.093.699-.253 1.012-.248.486-.643.881-1.128 1.129-.314.16-.649.223-1.012.253-.35.028-.78.028-1.3.028h-.054c-.521 0-.951 0-1.301-.028-.364-.03-.698-.093-1.012-.253a2.582 2.582 0 0 1-1.128-1.129c-.16-.313-.223-.648-.253-1.011-.029-.35-.029-.78-.029-1.301v-.054c0-.52 0-.95.029-1.3.03-.364.093-.698.253-1.012.247-.486.642-.88 1.128-1.128.314-.16.649-.224 1.012-.253.35-.029.78-.029 1.3-.029Z"
        clipRule="evenodd"
      />
    </motion.svg>
  )
}
